import type { SVGProps } from "react";

export function IconPurpleLiquidDollar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#FBF6FE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.25 20.75V40.75H40.75V20.75V15.7573V15.5H39.0499L37.9873 16.8662C37.1902 17.891 35.6604 17.9459 34.7919 16.9809L34.6359 16.8076C33.2375 15.2538 30.7794 15.3252 29.4735 16.9575C28.7181 17.9018 27.2819 17.9018 26.5265 16.9575L26.4735 16.8913C25.1872 15.2834 22.7888 15.1505 21.3328 16.6066L21.0794 16.86C20.064 17.8754 18.3734 17.708 17.5769 16.5131L16.9014 15.5H15.25V15.727V20.75ZM39.2002 17.75L39.25 17.6859V17.75H39.2002Z"
        fill="#2E2E2E"
      />
      <path
        d="M31.5 26.5C31.5 26.0055 31.2947 25.5222 30.9101 25.1111C30.5256 24.7 29.9789 24.3795 29.3394 24.1903C28.6999 24.0011 27.9961 23.9516 27.3172 24.048C26.6383 24.1445 26.0146 24.3826 25.5251 24.7322C25.0356 25.0819 24.7023 25.5273 24.5673 26.0123C24.4322 26.4972 24.5015 26.9999 24.7664 27.4567C25.0313 27.9135 25.4799 28.304 26.0555 28.5787C26.6311 28.8534 27.3078 29 28 29C28.6922 29 29.3689 29.1466 29.9445 29.4213C30.5201 29.696 30.9687 30.0865 31.2336 30.5433C31.4985 31.0001 31.5678 31.5028 31.4327 31.9877C31.2977 32.4727 30.9644 32.9181 30.4749 33.2678C29.9854 33.6174 29.3618 33.8555 28.6828 33.952C28.0039 34.0484 27.3002 33.9989 26.6606 33.8097C26.0211 33.6205 25.4744 33.3 25.0899 32.8889C24.7053 32.4778 24.5 31.9945 24.5 31.5"
        stroke="#2A222A"
        strokeWidth="1.5"
      />
      <path
        d="M28 24V23M28 35V34"
        stroke="#2A222A"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
